import { faUserAstronaut } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  StyledActions,
  StyledCta
} from 'components/marketingSite/shared/Cta.styled';
import ButtonLink from 'components/shared/ButtonLink.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { WP_REST_API_Post, WP_REST_API_Tags } from 'wp-types';

const BlogCta: React.FC<{
  post?: WP_REST_API_Post & {
    'te-tags': number[];
  };
  tags: WP_REST_API_Tags;
}> = ({ post, tags }) => {
  const { t } = useI18n('talent-engine-blog');
  const { locale } = useRouter();

  const hrAsAServiceTagId =
    Array.isArray(tags) && tags.length > 0
      ? tags.find((tag) => tag?.slug === 'hr-as-a-service')?.id
      : undefined;
  const hasHrAsAService =
    hrAsAServiceTagId && post?.['te-tags']?.includes(hrAsAServiceTagId);
  const hrAsAServicePrefix = hasHrAsAService ? 'hr-as-a-service.' : '';

  return (
    <StyledCta>
      <Heading3 editorial>
        {t(`talent-engine-blog.cta.${hrAsAServicePrefix}title`)}
      </Heading3>
      <HtmlTrans
        ns={'talent-engine-blog'}
        i18nKey={`talent-engine-blog.cta.${hrAsAServicePrefix}desc`}
      ></HtmlTrans>

      <StyledActions>
        <Link
          href={getAppUrl(
            hasHrAsAService
              ? APP_URLS.hrAsAService
              : APP_URLS.talentEngineLanding,
            locale
          )}
          passHref
        >
          <ButtonLink variant="brandTalent" sizes="md">
            <FontAwesomeIcon icon={faUserAstronaut} />
            <span>
              {t(`talent-engine-blog.cta.${hrAsAServicePrefix}action`)}
            </span>
          </ButtonLink>
        </Link>
      </StyledActions>
    </StyledCta>
  );
};

export default BlogCta;
